import script from "./FundraisingGoalsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FundraisingGoalsTable.vue?vue&type=script&setup=true&lang=js"

import "./FundraisingGoalsTable.vue?vue&type=style&index=0&id=53608bed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53608bed"]])

export default __exports__